import type { OfferRecipientCreateBody, OfferRecipientDTO } from '@today/models'
import { apiClient } from './api.client'

/** Offer wizard Step-1 recipient API (TO-122): role-scoped typeahead + inline prospect creation. */
export const offerRecipientService = {
	/** At most 10 recipients within the caller's reach whose name contains `q` (2–100 characters). */
	search: async (q: string) =>
		(await apiClient.get<{ data: OfferRecipientDTO[] }>('/offers/recipients', { params: { 'filters[q]': q } })).data
			.data,
	/** Create a prospect owned by the caller; returns it as a recipient. */
	createProspect: async (body: OfferRecipientCreateBody) =>
		(await apiClient.post<OfferRecipientDTO>('/offers/recipients', body)).data,
}
